import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";

const BlogPost = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);

    useEffect(() => {
        api.get(`/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setPost({ notfound: true }));
    }, [slug]);

    if (!post) return <div className="pt-40 st-container text-center text-[var(--st-ink-soft)]">Loading…</div>;
    if (post.notfound) return (
        <main className="pt-40 pb-24 st-container">
            <h1 className="font-serif text-5xl">Post not found.</h1>
            <p className="mt-4"><Link to="/blog" className="link-underline">Back to Journal</Link></p>
        </main>
    );

    return (
        <main data-testid="blog-post-page" className="bg-[var(--st-cream)]">
            <article>
                <section className="pt-36 lg:pt-44 pb-12">
                    <div className="st-container max-w-4xl">
                        <Link to="/blog" className="inline-flex items-center gap-2 eyebrow mb-8 text-[var(--st-gold-deep)] hover:text-[var(--st-ink)]">
                            <ArrowLeft size={14} /> Back to Journal
                        </Link>
                        <p className="eyebrow text-[var(--st-gold-deep)] mb-5">{post.category}</p>
                        <h1 className="font-serif leading-[0.95] tracking-tighter" style={{ fontSize: "clamp(2.5rem, 6vw, 5.5rem)" }}>
                            {post.title}
                        </h1>
                        <p className="mt-6 text-xs uppercase tracking-widest text-[var(--st-ink-soft)]">{post.author} · {new Date(post.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" })}</p>
                    </div>
                </section>

                <div className="st-container max-w-5xl">
                    <div className="aspect-[16/9] overflow-hidden">
                        <img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" />
                    </div>
                </div>

                <section className="py-20">
                    <div className="st-container max-w-3xl">
                        <p className="font-serif italic text-2xl md:text-3xl leading-snug mb-12 text-[var(--st-ink)]">{post.excerpt}</p>
                        <div className="prose-content text-lg leading-relaxed text-[var(--st-ink-soft)] space-y-6">
                            {post.content.split(/\n\n+/).map((para, i) => {
                                if (para.startsWith("## ")) {
                                    return <h2 key={i} className="font-serif text-3xl md:text-4xl mt-12 mb-2 text-[var(--st-ink)]">{para.replace(/^## /, "")}</h2>;
                                }
                                return <p key={i}>{para}</p>;
                            })}
                        </div>
                    </div>
                </section>
            </article>
        </main>
    );
};

export default BlogPost;
